let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("erkOs")).then(() => parcelRequire('ad0k2'));